import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { AuthClient } from '../auth/AuthClient';
export default function LoginPage() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        if (code) {
            AuthClient.handleCallback(code, state)
                .then(() => { window.location.href = '/'; })
                .catch(() => { window.location.href = '/login?error=callback_failed'; });
        }
        else if (!params.get('error')) {
            void AuthClient.startLogin();
        }
    }, []);
    const error = new URLSearchParams(window.location.search).get('error');
    if (error) {
        return (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8, gap: 2 }, children: _jsx(Typography, { color: "error", children: "Login failed. Please try again." }) }));
    }
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8, gap: 2 }, children: [_jsx(CircularProgress, {}), _jsx(Typography, { children: "Redirecting to login\u2026" })] }));
}
